import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16678 24244"
    {...props}
  >
    <path
      d="M2746 0h10939c1054 0 1816 162 2287 493 471 325 706 869 706 1625 0 460-275 1065-830 1822-554 756-1182 1591-1888 2505-706 913-1435 2045-2186 3402-751 1356-1440 3015-2062 4976-264 863-448 1580-560 2146-107 572-230 1312-359 2219-135 908-247 1604-348 2085-229 1115-554 1889-975 2320-426 432-986 651-1687 651-666 0-1205-230-1608-695-409-466-611-1155-611-2063 0-700 152-1653 443-2852 297-1205 779-2646 1446-4327 672-1675 1507-3401 2510-5167 998-1765 2192-3525 3570-5273H2746c-925 0-1608-168-2062-505C230 3032 0 2505 0 1793 0 1037 241 549 723 331 1205 112 1878 0 2746 0z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
